import React, { useCallback, useRef } from 'react';
import * as S from './style';
import { imageUpload, deleteFile } from 'commons/ZimssaHelper';

interface Props {
    children: React.ReactNode | string;
    inputName: string;
    imgDir: string;
    height?: number;
    backGroundColor?: string;
    boarderColor?: string;
    color?: string;
    fontStyle?: string;
    radius?: number;
    onChangeHandler?: (type: any, value: string, imgName: string) => void;
}

function BtnFile({ children, inputName, imgDir, onChangeHandler, ...props }: Props): React.ReactElement {
    const inputRef = useRef<HTMLInputElement>(null);

    const onChangeFile = useCallback(
        async () => {
            try {
                const { data, file } = await imageUpload(inputRef, imgDir, 1024 * 1024 * 10);

                deleteFile(inputRef);
                onChangeHandler && onChangeHandler(inputName, data, file.name);
            } catch (error) {
                let message = 'Unknown Error';

                if (error instanceof Error) {
                    if (error.message === 'NO FILE SELECTED') return;
                    message = error.message;
                }

                alert(message);
            }
        },
        [imgDir, inputName, onChangeHandler]
    );

    return (
        <S.FileWrapper {...props}>
            <S.InputFile
                type={'file'}
                accept={'image/*'}
                ref={inputRef}
                onChange={onChangeFile}
                title={''}
            />
            {children}
        </S.FileWrapper>
    );
}

export default BtnFile;
